const BILLING_FREQUENCY_LABELS = {
  bimonthly: '2 months',
  semi_annual: '6 months'
}

const billingFrequencyFormat = function ($filter) {
  'ngInject'

  return function (frequency) {
    if (!frequency) {
      return frequency
    }

    if (BILLING_FREQUENCY_LABELS[frequency]) {
      return BILLING_FREQUENCY_LABELS[frequency]
    }

    return $filter('underscoreStrip')(frequency)
  }
}

export default billingFrequencyFormat
